import React, { Component } from 'react';
import { Container, Accordion, Icon } from 'semantic-ui-react';
import { PtInput, PtInputIcon, PtInputIconElevation, EditGeographicPoint, PtSelect, PtDateInput } from '../../../grit-utilities';
import DropdownLib from '../../../DropdownLib';
import 'semantic-ui-css/semantic.min.css';
import '../../../index.css';
import ScrollArea from 'react-scrollbar';
import $ from 'jquery';
import config from '../../../config.json'

export default class Support extends Component {
    constructor(props) {
        super(props);
        this.state = this.props.pointModel
    }

    render() {
        const { supportOptions, supportNumberOptions } = DropdownLib.getDropdowns().Signs_Support;
        return (
            <Container>
                <PtSelect label="Support Type" options={supportOptions} disabled={this.props.disabled}
                    name="SupportType" defaultVal={this.state.Support.SupportType === null ? 0 : this.state.Support.SupportType}
                    onChange={this.onChangeDropdown} />
                <input
                    onChange={this.onCheckedChange}
                    checked={this.state.Support.Breakway}
                    name='Breakway'
                    type="checkbox" /> <label>Breakaway</label>

                <PtSelect label="Number of Supports" options={supportNumberOptions} disabled={this.props.disabled}
                    name="NumberofSupports" defaultVal={this.state.Support.NumberofSupports === null ? 0 : this.state.Support.NumberofSupports}
                    onChange={this.onChangeDropdown} />

                <PtInput label="Support Length (ft.)" inputType="number" value={this.state.Support.SupportLength === null ? '' : this.state.Support.SupportLength}
                    onChange={this.onInputChange} name="SupportLength" disabled={this.props.disabled} />

                <PtInput label="Support Post Size (inches)" inputType="number" value={this.state.Support.PostSize === null ? '' : this.state.Support.PostSize}
                    onChange={this.onInputChange} name="PostSize" disabled={this.props.disabled} />

                <PtDateInput label='Installed Date' placeholder="Not Available" whichInput="firsttb" inputType="hwy" name="CreatedDate"
                    disabled={this.props.disabled}
                    value={this.state.Support.CreatedDate ? this.state.Support.CreatedDate.slice(0, 10) : null} onChange={(date) => this.onChangeDate(date, "CreatedDate")} />
            </Container>


        )

    }
    onInputChange = (e) => {
        const { name, value } = e.target;
        this.props.triggerNeedSave();
        this.setState({ [name]: value === '' ? null : value });
        this.props.pointModel.Support[name] = value
    }

    onChangeDropdown = (e) => {
        const { target } = e;
        const { name, value } = target;
        this.props.triggerNeedSave();
        // eslint-disable-next-line
        this.setState({ [name]: parseInt(value) });
        this.props.pointModel.Support[name] = value;
    }
    onCheckedChange = (e) => {
        const { target } = e;

        const { name } = target;
        this.props.triggerNeedSave();
        this.setState({ [name]: !this.state.Support[name] });
        this.props.pointModel.Support[name] = !this.state.Support[name];
    }

    onChangeDate = (date, name) => {
        this.props.triggerNeedSave();
        if (date instanceof Date && !isNaN(date)) {
            this.setState({ [name]: date ? `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}` : null });
        }
        else {
            this.setState({ [name]: null });
        }
        this.props.pointModel.Support[name] = date ? `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}` : null;
    }


}


// WEBPACK FOOTER //
// ./src/layers/tabs/sign/support.js